import { useCallback, useEffect } from 'react'
import { getSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import { isReportsHandlerLoading, reportsHandlerTableData } from 'Pages/Admin/ReportsHandler/@signals'
import { useToast } from '@hooks'

export default function useReportsHandlerFilters(userId) {
	const { showToast } = useToast()


	const handleSubmitFilters =  useCallback(() => {
		getSubmit(`${BACKEND_APIS.REPORTS}/list?slaveID=${userId}`)
			.then(data => {
				reportsHandlerTableData.value = data
				isReportsHandlerLoading.value = false
			})
			.catch(() => {
				isReportsHandlerLoading.value = false
				showToast.error()
			})
	}, [userId])

	useEffect(() => {
		if(isReportsHandlerLoading.value && !!userId) handleSubmitFilters()
	}, [isReportsHandlerLoading.value, userId])

}